var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import dayjs from 'dayjs';
import lodash from 'lodash';
import { action, observable } from 'mobx';
import { BehaviorSubject, interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { BaseModel } from './../../libraries';
const flagEnum = {
    101: '直播间已禁止聊天',
    102: '您已被禁言，请见谅',
    103: '消息发送失败',
};
export class CommentController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
        //特殊评论
        this.gitfList = [];
        //特殊评论队列
        this.gitfQueue = new BehaviorSubject(this.gitfList);
    }
    //评论
    get commentsList() {
        return lodash.get(this.Model.value, 'commentsList', []);
    }
    /**
     * @description: 获取评论
     */
    onGetComments() {
        Mudu.Room.Comment.Get(
        // 要获取评论的页码，类型为int
        0, 
        // 评论获取成功的回调函数，参数为response对象
        (response) => {
            response = JSON.parse(response);
            if (response.status === 'y') {
                const comments = lodash.get(response, 'data.comments', []);
                this.Model.merge({
                    commentsList: comments,
                });
            }
            if (response.status === 'n') {
                console.log('获取评论失败');
            }
        });
    }
    onDeleteId(id) {
        const commentsList = lodash.cloneDeep(this.commentsList);
        lodash.remove(commentsList, (item) => {
            return lodash.eq(item.id, id);
        });
        this.Model.merge({
            commentsList,
        });
    }
    /**
     * @description: 发送评论
     */
    onSendComments(comment) {
        return new Promise((reslove, reject) => {
            let comments;
            if (comment.indexOf('http') != -1) {
                comments = encodeURIComponent(JSON.stringify({
                    'src': comment,
                    'name': '免费道具',
                    'number': 1,
                    'msg_type': '40',
                }));
            }
            else {
                comments = comment;
            }
            Mudu.Room.Comment.Send(
            // 要发送的评论文本，类型为string
            comments, 
            // 发送完成的回调函数，参数为response对象
            (response) => {
                response = JSON.parse(response);
                if (response.status === 'y') {
                    reslove('发送成功');
                }
                if (response.status === 'n') {
                    reject(lodash.assign(response, {
                        message: lodash.get(flagEnum, response.flag, '消息发送失败'),
                    }));
                    console.log('发送失败，错误码为：' + response.flag);
                }
            });
        });
    }
    onCommentListener() {
        this.onClearExpiredData();
        Mudu.MsgBus.On(
        // 事件名，值为Comment.New
        'Comment.New', 
        // 事件处理函数，参数为新的评论，类型为object
        (newComment) => {
            newComment = JSON.parse(newComment); // newComment 结构见页面底部
            if (newComment.message) {
                newComment.message = msgParse(newComment.message);
                newComment.msg_type = lodash.get(newComment.message, 'msg_type', newComment.msg_type);
                if (newComment.msg_type == '40') {
                    this.onAddToQueue(newComment);
                }
                this.Model.merge({
                    commentsList: lodash.concat(this.commentsList, [newComment]),
                });
            }
        });
        Mudu.MsgBus.On(
        // 事件名，值为Comment.Delete
        'Comment.Delete', 
        // 事件处理函数，参数为被删除的评论，类型为object
        (newComment) => {
            newComment = JSON.parse(newComment); // newComment 结构见页面底部
            this.onDeleteId(newComment.id);
        });
    }
    onAddToQueue(comment) {
        const { visitor_id, message, dateline } = comment;
        const key = visitor_id + message.src;
        const findIndex = lodash.findIndex(this.gitfList, (item) => {
            return item.key == key;
        });
        if (findIndex != -1) {
            this.gitfList[findIndex].number += 1;
            this.gitfList[findIndex].time = dateline;
        }
        else {
            const obj = {
                key: visitor_id + message.src,
                time: dateline,
                number: 1,
                src: comment.message?.src,
                ...comment,
            };
            this.gitfList.push(obj);
        }
        this.gitfQueue.next(this.gitfList);
    }
    getContainerNumber() {
        const liveComments = document.querySelector('#live-comments');
        if (liveComments) {
            //文字在聊天区域显示的高度
            const containerHeight = liveComments.clientHeight / 3;
            //能显示的个数
            const number = Math.floor(containerHeight / 50);
            //最少显示一个
            const gitfNumber = number > 1 ? number : 1;
            return gitfNumber;
        }
    }
    clearExpiredData() {
        const currentTime = dayjs();
        const number = this.getContainerNumber();
        //根据时间戳排序
        const sortGiftList = lodash.sortBy(this.gitfList, (item) => new Date(item.timestamp * 1000));
        const sliceGiftKeys = lodash.map(lodash.slice(sortGiftList, -number), (item) => {
            return item.key;
        });
        // 过滤出未过期的数据
        this.gitfList = this.gitfList.filter((item) => {
            const itemTime = dayjs.unix(item.time);
            const timeDifference = Math.abs(currentTime.diff(itemTime, 'seconds'));
            if (timeDifference > 15 || !lodash.includes(sliceGiftKeys, item.key)) {
                return false;
            }
            return true;
        });
        this.gitfQueue.next(this.gitfList);
    }
    //保持持续监测 清空过期评论
    onClearExpiredData() {
        interval(1000)
            .pipe(takeWhile(() => true))
            .subscribe(this.clearExpiredData);
    }
}
__decorate([
    observable
], CommentController.prototype, "gitfList", void 0);
__decorate([
    action.bound
], CommentController.prototype, "onAddToQueue", null);
__decorate([
    action.bound
], CommentController.prototype, "clearExpiredData", null);
function msgParse(msg) {
    try {
        const msgStr = decodeURIComponent(msg);
        const msgObj = JSON.parse(msgStr);
        return msgObj;
    }
    catch (error) {
        return msg;
    }
}
